import { ContatoStatusTypes } from 'store/reducers/contatos';

export default function getContatoStatusLabel(status: ContatoStatusTypes) {
  switch (status) {
    case 'INVALIDO':
      return 'Inválido';
    case 'VALIDO':
      return 'Válido';
    case 'NAO_VERIFICADO':
      return 'Não verificado';
    default:
      return '';
  }
}
